import * as React from 'react'
import { withConfig } from  '../../common/modules/config'
import { withFields } from '../../common/modules/fields'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withErrors } from '../../common/modules/errors'
import { withRestore } from '../../common/modules/restore'
import { withForm } from '../../common/modules/form'
import { withValidation } from '../../common/modules/validation'
import { withQuoteSupport } from '../../common/modules/quote-support'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { get, isNumber } from 'lodash'
import InputField from '../components/input-field'
import StandardInput from '../components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../components/recaptcha'
import StepTitle from '../components/step-title'
import SubHeader from '../components/sub-header'
import StepBlock from '../components/step-block'
import Button from '../components/button'
import QueryString from 'query-string'


export const formConfig = state => {
    const fieldNames = state.restore.fieldNames;
    
    return {
        rules: {
            [fieldNames.quoteNumber]:[
                Validation.enforce.required("Please enter a valid quote number."),
            ],
            [fieldNames.email]:[
                Validation.enforce.required("Please type a valid email address"),
                Validation.enforce.email("Please type a valid email address.")
            ]
        },

        options:{},
        predicates:{},
        inferred:{},
        
        transformOut: data => {}

    }

}



@withSubmission
@withNavigation
@withValidation
@withFields
@withRestore
@withQuoteSupport
@withScrollToTop
@withForm(formConfig)
class Restore extends React.Component<any, any>{


    componentDidMount(){
        const extracted = QueryString.extract(window.location.href);
        const parsed = QueryString.parse(extracted)
        if(parsed.step)
            this.props.actions.fields.updateField("requestedStep", parsed.step);
        if(parsed.token)
            this.props.actions.fields.updateField("token", parsed.token);
        if(parsed.successful)
            this.props.actions.fields.updateField("successful", JSON.parse(parsed.successful));
        if(parsed.reason)
            this.props.actions.fields.updateField("reason", parsed.reason);
        if(parsed.policyNumber)
            this.props.actions.fields.updateField("policyNumber", parsed.policyNumber);

        if(parsed.token)
            this.retrieveDetails(parsed.token);
    }

    render(){
        const fieldNames = this.props.restore.fieldNames;

        return (
            <div className="row">
                <StepTitle>Retrieve quote</StepTitle>

                <InputField field={ fieldNames.quoteNumber }         label="Your quote number" /> 
                <InputField field={ fieldNames.email }               label="Your email" /> 
              
                <Button.Container>
                    <Button.Continue onClick={ this.onNext.bind(this)} />
                </Button.Container>
            </div>
        )        
    }


    onNext(e){
        this.props.actions.validation.validate( this.findToken.bind(this) )
    }


    findToken(){
        console.log("Find token")
        const fieldNames = this.props.restore.fieldNames;
        const fields = this.props.fields;
        const endpoint = this.props.quoteSupport.endpoints.findToken;
        const data = {
            quoteNumber: get( this.props.fields, fieldNames.quoteNumber ),
            requesterEmail: get( this.props.fields, fieldNames.email )
        }

        this.props.actions.submission.post(endpoint, this.retrieveDetails.bind(this), data)
    }


    retrieveDetails(token=null){
        console.log("Retrieve details")
        const fields = this.props.fields
        const endpoint = this.props.quoteSupport.endpoints.restore;
        if(token == null) token = fields.token

        this.props.actions.submission.get(endpoint + "?token=" + token, this.transformFields.bind(this))
    }


    transformFields(){
        console.log("Transform fields")
        const transformer = this.props.restore.transformer;
        this.props.actions.fields.updateFields( transformer(this.props.fields) )
        this.proceed();
    }


    proceed(){
        console.log("Proceed");
        const stepIndex = this.props.fields.requestedStep || ("/step-" + this.props.fields.step);
        this.props.actions.navigation.changeRoute(stepIndex);
    }

}


export default Restore;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/restore.tsx